import './App.css';
import React from 'react';
import { Security, LoginCallback, useOktaAuth } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import MainView from './views/MainView'
import { getConfig } from "./config";

const config = getConfig();

const oktaAuth = new OktaAuth({
  issuer: config.okta.issuer,
  clientId: config.okta.clientId,
  redirectUri: window.location.origin + '/login/callback'
});

const Index: React.FunctionComponent = () => {
  const { oktaAuth, authState } = useOktaAuth();

  const login = async () => oktaAuth.signInWithRedirect();
  if(!authState) {
    return <div>Loading...</div>;
  }
  if(authState.isAuthenticated || process.env.NODE_ENV === 'development') {
    return <MainView />;
  }
  return (
    <div>
      <p>Not Logged in yet</p>
      <button onClick={login}>Login</button>
    </div>
  );
};

const MainPage = () => {
  const navigate = useNavigate();
  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/login/callback" element={<LoginCallback/>} />
        </Routes>
      </Security>
  );
};

const App = () => (
  <Router>
    <MainPage />
  </Router>
);

export default App;